<template>
  <div class="catActions">
    <chooseDialog
      :category="category"
      :dialog="chooseDialogVal"
      @closed="chooseDialogClosed"
      @choosed="chooseDialogReply"
    />
    <v-tooltip top v-if="permissions.catalog.categories.actions.edit">
      <template v-slot:activator="{ on }">
        <v-btn icon @click.stop="toggleCat(category)" v-on="on" small>
          <v-icon small>{{ (!category.active ? 'mdi-checkbox-marked-circle-outline' : 'mdi-cancel') }}</v-icon>
        </v-btn>
      </template>
      <span>{{ (!category.active ? lang.items.status.activate : lang.items.status.deactivate) }}</span>
    </v-tooltip>
    <v-tooltip top v-if="permissions.catalog.categories.actions.edit">
      <template v-slot:activator="{ on }">
        <v-btn icon @click.stop="$emit('edit', category)" v-on="on" small>
          <v-icon small>mdi-playlist-edit</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.items.actions.edit }}</span>
    </v-tooltip>
    <v-tooltip top v-if="permissions.catalog.categories.actions.delete">
      <template v-slot:activator="{ on }">
        <v-btn icon @click.stop="deleteCat(category)" v-on="on" small>
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.items.actions.delete }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import catActions from '../mixins/actions'
import chooseDialog from './chooseDialog'

import appdata from '@/mixins/appdata'

export default {
  components: { chooseDialog },
  mixins: [ appdata, catActions ],
  props: {
    category: {
      type: Object,
      required: true
    },
    catalog: {
      type: String,
      required: true
    }
  }
}
</script>

<style>
.catActions {
  width: 95px !important;
  position: absolute;
  top: 21%;
  right: 5px;
}
</style>
